export const privateLayoutStyles = (theme) => ({
  root: { height: '100vh', display: 'flex', flexDirection: 'column' },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.common.white,
    minHeight: '80px',
    padding: '0 2%',
  },
  headerLeftContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      order: '2',
    },
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
  },
  menu: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      order: '1',
    },
  },
  headerRightContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '1em',
    [theme.breakpoints.down('sm')]: {
      order: '3',
    },
  },
  bodyWrapper: {
    flex: 1,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-center',
    flexDirection: 'column',
  },
  iconButton: { color: theme.palette.common.black },
  mainArea: { flex: 1, display: 'flex', minHeight: 'calc(100vh - 80px)', flexDirection: 'column' },
  footerWrapper: {
    backgroundColor: '#000000',
    color: '#f8f7f7',
    minHeight: '120px',
    textAlign: 'center',
  },
  footerContent: {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 30,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 15,
    },
  },
  footerLink: { margin: '0 2%', color: '#f8f7f7', textDecoration: 'underline', cursor: 'pointer' },
})
